// extracted by mini-css-extract-plugin
export default {"container":"container_container__srhc2","sidebar":"container_sidebar__zGtfE","banner":"container_banner__YovXd","content":"container_content__iqp-l"};